export const SUBSCRIPTION_PACKAGE_COLLECTION_SOURCE_SYSTEM = 'tukios_flowers'
export const SUBSCRIPTION_PACKAGE_COLLECTION_SOURCE_KEY = 'subscription-packages'
export const SUBSCRIPTION_PACKAGE_COLLECTION_SMART_RULE = 'subscription_packages'

export const subscriptionPackageCollectionFilters = {
  smart_rule: SUBSCRIPTION_PACKAGE_COLLECTION_SMART_RULE,
}

/** The fields that identify the platform's Subscriptions collection. */
interface CollectionSource {
  source_system?: string | null
  source_key?: string | null
}

export function isSubscriptionPackageCollection(
  collection: CollectionSource | null | undefined
): boolean {
  return (
    collection?.source_system === SUBSCRIPTION_PACKAGE_COLLECTION_SOURCE_SYSTEM &&
    collection?.source_key === SUBSCRIPTION_PACKAGE_COLLECTION_SOURCE_KEY
  )
}

/** Finds the Subscriptions collection in a collection list or page. */
export function findSubscriptionPackageCollection<TCollection extends CollectionSource>(
  collections: TCollection[] | { data?: TCollection[] } | null | undefined
): TCollection | null {
  const collectionList = Array.isArray(collections) ? collections : (collections?.data ?? [])

  return collectionList.find(isSubscriptionPackageCollection) ?? null
}
